import { frontendURL } from 'dashboard/helper/URLHelper';

import SettingsWrapper from 'dashboard/routes/dashboard/settings/SettingsWrapper.vue';
import ClientSettingsHome from './Index.vue';
import CurrencyMigrationIndex from './currencyMigration/Index.vue';
import CurrencyMigrationShow from './currencyMigration/Show.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/client-settings'),
      component: SettingsWrapper,
      // SettingsWrapper keeps its pages alive by default. The migration detail page would
      // then be restored from cache with the previous migration's id still captured, and
      // every page here shows state that moves on its own, so each visit must remount and
      // re-read.
      props: { keepAlive: false },
      children: [
        {
          path: '',
          redirect: 'show',
        },
        {
          path: 'show',
          name: 'client_settings_index',
          meta: {
            permissions: ['administrator'],
          },
          component: ClientSettingsHome,
        },
        {
          path: 'currency-migration',
          name: 'client_settings_currency_migrations',
          meta: {
            permissions: ['administrator'],
          },
          component: CurrencyMigrationIndex,
        },
        {
          path: 'currency-migration/:migrationId',
          name: 'client_settings_currency_migration_show',
          meta: {
            permissions: ['administrator'],
          },
          component: CurrencyMigrationShow,
        },
      ],
    },
  ],
};
